import * as React from "react";
import { User } from "../../userTypes";
import { Button, Tooltip } from "@material-ui/core";
import ThumbDown from "@material-ui/icons/ThumbDown";

type Props = {
  user: User;
  onUserChanged: (user: User) => void;
  onClick: (params?: any) => any;
  disabled: boolean;
  fetchingData: boolean;
};

export default class ManualVerificationRejectButton extends React.Component<
  Props
> {
  constructor(props: Props) {
    super(props);
    props.onUserChanged(props.user);
  }

  componentWillReceiveProps(newProps: Props) {
    if (newProps.user !== this.props.user) {
      newProps.onUserChanged(newProps.user);
    }
  }

  render() {
    return this.props.disabled === false &&
      this.props.fetchingData === false ? (
      <Button
        color="secondary"
        variant="contained"
        className="button no-margin"
        onClick={this.props.onClick}
        disabled={this.props.disabled}
      >
        Reject user
        <ThumbDown
          style={{
            marginLeft: "10px",
          }}
        />
      </Button>
    ) : (
      <Tooltip
        title="There must be a manual verification request associated with the user, with a status of in_review, for the request to be rejected."
        placement="bottom-start"
      >
        <span>
          <Button
            color="secondary"
            variant="contained"
            className="button no-margin"
            onClick={this.props.onClick}
            disabled={this.props.disabled}
          >
            Reject user
            <ThumbDown
              style={{
                marginLeft: "10px",
              }}
            />
          </Button>
        </span>
      </Tooltip>
    );
  }
}
